module.exports = __webpack_public_path__ + "static/media/bushu-04.bd3d3ef4.png";